"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPathNode_1 = __importDefault(require("./isPathNode"));
const isFilter = (type) => type === 'filter';
function isFilterNode(node) {
    return !isPathNode_1.default(node) && isFilter(node.type_of);
}
exports.default = isFilterNode;
